<template>
	<el-card class="menuBody" shadow="never">
		<left-project-tree @chooseNode="selectNode" style="height: 100%; overflow: auto;"></left-project-tree>
		<div class="menuTool" style="width:100%;">
			<el-card class="box-card">
				<el-row :gutter="10">
					<div class="search-title">
						续费审核
					</div>
					<div class="search-input-item">
						<dict-select size="small" v-model="query.auditState" placeholder="审核状态" :dict="auditState" clearable></dict-select>
					</div>
					<div class="search-input-item">
						<el-select clearable size="small" v-model="query.parkId" placeholder="车场">
							<el-option v-for="item in parks" :key="item.parkId" :label="item.parkName" :value="item.parkId" clearable></el-option>
						</el-select>
					</div>
					<div class="search-input-item">
						<el-input size="small" v-model="query.plateNumber" placeholder="车牌号" clearable></el-input>
					</div>

					<div class="search-button-tools">
						<el-button size="small" type="primary" :loading="tableLoading" @click="doSearch">查询</el-button>
					</div>

					<el-table :data="tableData" row-key="id" border v-loading="tableLoading" tooltip-effect="light" :stripe="true">
						<el-table-column width="250" show-overflow-tooltip prop="parkName" label="车场"></el-table-column>
						<el-table-column width="200" show-overflow-tooltip prop="plateNumber" label="车牌"></el-table-column>
						<el-table-column width="200" show-overflow-tooltip prop="carType" label="车类">
							<template slot-scope="scope">
								<span>{{ scope.row.carType | dictLabel(carType) }}</span>
							</template>
						</el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="owner" label="车主"></el-table-column>
						<el-table-column width="120" show-overflow-tooltip prop="roomInfo" label="房产"></el-table-column>
						<el-table-column width="150" show-overflow-tooltip prop="mobile" label="手机号"></el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="num" label="缴费月数"></el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="filed6" label="实际生效月数"></el-table-column>
						<el-table-column width="200" show-overflow-tooltip prop="payAmount" label="缴费金额（元）">
							<template slot-scope="scope">
								<span>{{ scope.row.payAmount | toYuan() }}</span>
							</template>
						</el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="payMemo" label="费用说明"></el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="payMemo" label="新有效期">
							<template slot-scope="scope">
								<span>{{ scope.row.beginTime | dateFmt('YYYY-MM-DD') }}</span>
								至
								<span>{{ scope.row.endTime | dateFmt('YYYY-MM-DD') }}</span>
							</template>
						</el-table-column>
						<el-table-column width="100" show-overflow-tooltip prop="auditState" label="审核状态">
							<template slot-scope="scope">
								<span :style="getCheckStatusStyle(scope.row.auditState)">{{ scope.row.auditState | dictLabel(auditState) }}</span>
							</template>
						</el-table-column>
						<el-table-column width="350" show-overflow-tooltip prop="createDate" label="提交时间"></el-table-column>
						<el-table-column width="300" fixed="right" label="操作">
							<template slot-scope="scope">
								<div v-show="scope.row.auditState == 0">
									<el-button @click="doAgree(scope.row)" type="text" size="small">通过</el-button>
									<el-button @click="doRefuse(scope.row)" type="text" size="small">驳回</el-button>
								</div>
							</template>
						</el-table-column>
					</el-table>
					<simple-pagination @search="doSearch" />
				</el-row>
			</el-card>
		</div>
	</el-card>
</template>
<script>
import "@/assets/scss/common.scss";
import mixin from "@/mixin/index";
import { carType, auditState, needConfirm } from "@/dict/carDict";
import { pick, omit, assign } from "lodash";
import { get, post, alertMultiMessage, alertSingleMessage } from "@/assets/common/request";
import LeftProjectTree from "@/components/LeftProjectTree.vue";
export default {
	name: "RenewalCardAudit",
	mixins: [mixin],
	components: { LeftProjectTree },
	data() {
		return {
			carType,
			auditState,
			needConfirm,
			queryListUrl: "/car/listPageRenewalAuditList",
			parks: [],
		};
	},
	methods: {
		/**
		 * 查询
		 */
		doSearch() {
			this.getListPost();
		},
		/**
		 * 通过
		 */
		doAgree(row) {
			this._tip("您确认要通过审核吗？", () => {
				const url = "/car/renewBackend/agree";
				const data = { cardId: row.cardId };
				post(url, data).then((data) => {
					alertSingleMessage(data);
					this.doSearch();
				});
			});
		},
		/**
		 * 驳回
		 */
		doRefuse(row) {
			this.$prompt("请输入驳回理由", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				inputValidator: (val) => {
					if (!val) {
						return "驳回理由必须填写";
					}
				},
			})
				.then(({ value }) => {
					const url = "/car/renewBackend/refuse";
					const data = {
						cardId: row.cardId,
						remarks: value,
					};
					post(url, data).then((data) => {
						alertSingleMessage(data);
						this.doSearch();
					});
				})
				.catch(() => {
					// 取消按钮触发，不需要操作
				});
		},
		/**
		 * 获取审核状态的样式
		 */
		getCheckStatusStyle(auditState) {
			if (auditState == -1) {
				return {
					color: "#f00",
				};
			} else if (auditState == 0) {
				return {
					color: "#a00",
					background: "yellow",
				};
			} else {
			}
		},
		/**
		 * 加载车场
		 */
		loadParks() {
			const url = '/car/web/common/parkList';
            const params = {
                projectId: this.query.projectId
            }
			get(url, params).then((res) => {
                const data = res.data;
                this.parks = data;
			})
		},
		selectNode(data) {
			this.query = assign(this.query, data);
            this.query.projectId = '4da7e7cb2a78415a81cd6ee7dcf87f3e';
			this.doSearch();
			this.loadParks();
		},
	},
	mounted() {
		this.doSearch();
	},
};
</script>
